﻿// Include self executing modules here:

define([
    "log",
    //'../utils/common',
    "../build/areas/customers/customerDetails",
    "../build/areas/customers/customerNotes",
    "../build/areas/customers/customerImages",
    "../build/areas/customers/customers",
    "../build/areas/todos/todos",
    "../build/areas/phoneNumbers/phoneNumbers",
    "../build/areas/phoneNumbers/phoneNumberDetails",
    "../build/areas/phoneNumbersAudit/phoneNumbersAudit",
    "../build/areas/officeLocations/officeLocations",
    "../build/areas/e911/e911",
    "../build/areas/settings/agents",
    "../build/areas/settings/plans",
    "../build/areas/settings/customerNoteCategories",
    "../build/areas/settings/companySettings",
    "../build/areas/settings/serviceTypes",
    "../build/areas/settings/productTypes",
    "../build/areas/settings/customerStatuses",
    "../build/areas/settings/phoneNumberStatuses",
    "../build/areas/settings/projectManagers",
    "../build/areas/settings/accountManagers",
    "../build/areas/settings/domains",
    "../build/areas/settings/customerTypes",
    "../build/areas/phoneNumberProviders/phoneNumberProviders",
    "../build/areas/phoneNumberProviders/phoneNumberProviderDetails",
    "../build/areas/dns/dnsList",
    "../build/areas/dns/dnsDetails",
    "../build/areas/servers/servers",
    "../build/areas/servers/serverDetails",
    "../build/areas/betterLogs/betterLogs",
    "../build/areas/callDetailRecord/callDetailRecords",
    "../build/areas/reports/activityDashboard",
    "../build/areas/reports/usersDashboard",
    "../build/areas/reports/groupsDashboard",
    "../build/areas/reports/callLogs",
    "../build/areas/reports/cdrSummaryReport",
    "../build/areas/reports/agentGroupsSummaryReport",
    "../build/areas/reports/callDetailsReport",
    "../build/areas/reports/customersCreationReport",
    "../build/areas/reports/e911Report",
    "../build/areas/reports/customerPlansReport",
    "../build/areas/reports/customersNotesReport",
    "../build/areas/reports/customersPbxReport",
    "../build/areas/reports/customersSoftPhoneSummaryReport",
    "../build/areas/reports/customersSoftPhoneUserSummaryReport",
    "../build/areas/reports/messagingSummaryReport",
    "../build/areas/reports/customersContactsReport",
    "../build/areas/reports/unbilled-cdr",
    "../build/areas/serversGroups/serversGroups",
    "../build/areas/adminConsole/adminConsole",
    "../build/areas/customerCoordinator/customerCoordinators",
    "../build/areas/serversGroups/serverDetails",
    "../build/areas/users/users",
    "../build/areas/helpscout/helpscout",
    "../build/areas/register/register",
    "../build/areas/accounting/dailyInvoices",
    "../build/areas/documentCategory/documentCategory",
    "../build/areas/firewall/firewalls",
    "../build/areas/roleGroup/role-groups",
    "../build/areas/account/login",
    "../build/areas/account/profile",
    "../build/areas/account/resetPassword",
    "../build/areas/productCategory/productCategory",
    "../build/areas/products/products",
    "../build/areas/employeeRole/employeeRole",
    "../build/areas/employee/employees",
    "../build/areas/employee/employeeDetails",
    "../build/areas/suppliers/suppliers",
    "../build/areas/suppliers/commissions",
    "../build/areas/commission/commissionsReport",
    "../build/areas/customerPortalAdmin/customerProfiles",
    "../build/areas/customerPortalAdmin/customerProfileDetails",
    "../build/areas/customerPortalAdmin/customerUsers",
    "../build/areas/customerPortalAdmin/cpPackages",
    "../build/areas/customerPortalAdmin/cpPackagesDetails",
    "../build/areas/tags/tags",
    "../build/areas/cloudFiles/cloudFiles",
], function (log) {
    log.debug("All entry modules loaded.");
});


//////////////////
// WEBPACK FOOTER
// ./shim/modules.js
// module id = 65
// module chunks = 2